/* @flow */
import * as React from "react";

function Surface(props: Object) {
  return (
    <svg fill="none" style={{ flex: 1, zIndex: 1 }} {...props} />
  );
}

export default Surface;



// WEBPACK FOOTER //
// ./src/components/Chart/Surface.js